(() => {
  const root=document.querySelector("[data-azurial-header]");
  if(!root)return;
  const closeAll=()=>root.querySelectorAll("[data-mobile-subnav-panel]").forEach(p=>p.hidden=true);
  root.addEventListener("click",e=>{
    const trigger=e.target.closest("[data-mobile-subnav-trigger]");
    if(!trigger)return;
    const key=trigger.dataset.mobileSubnavTrigger;
    const panel=root.querySelector(`[data-mobile-subnav-panel="${key}"]`);
    const opening=panel?.hidden;
    closeAll();
    root.querySelectorAll("[data-mobile-subnav-trigger]").forEach(b=>b.setAttribute("aria-expanded","false"));
    if(panel&&opening){panel.hidden=false;trigger.setAttribute("aria-expanded","true");}
  });
  document.addEventListener("click",e=>{
    if(!root.contains(e.target)) closeAll();
  });
})();